export const setValidationCheckState = (state, action): any => {
  const updatedState = {
    ...state,
    validateCheck: action.payload.validateCheck,
  };

  return updatedState;
};
